import { c as _c } from "react/compiler-runtime";
import { SearchX, LucideIcon } from 'lucide-react';
import { getTranslations } from 'next-intl/server';
type PropsType = {
  title?: string;
  icon?: LucideIcon;
  className?: string;
};
const EmptyState = async t0 => {
  const $ = _c(12);
  const {
    title,
    icon: t1,
    className: t2
  } = t0;
  const Icon = t1 === undefined ? SearchX : t1;
  const className = t2 === undefined ? "" : t2;
  let t3;
  if ($[0] !== title) {
    const t = await getTranslations();
    t3 = title || t("no_results_found");
    $[0] = title;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const displayTitle = t3;
  const t4 = `bg-card/50 flex min-h-100 items-center justify-center rounded-xl border border-dashed ${className}`;
  let t5;
  if ($[2] !== Icon) {
    t5 = <div className="bg-muted mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full"><Icon className="text-muted-foreground h-8 w-8" /></div>;
    $[2] = Icon;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== displayTitle) {
    t6 = <p className="text-muted-foreground text-lg font-medium">{displayTitle}</p>;
    $[4] = displayTitle;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t5 || $[7] !== t6) {
    t7 = <div className="text-center">{t5}{t6}</div>;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t7) {
    t8 = <div className={t4}>{t7}</div>;
    $[9] = t4;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
};
export default EmptyState;